import { render, staticRenderFns } from "./AsDetailComp.vue?vue&type=template&id=4afde91a&scoped=true"
import script from "./AsDetailComp.vue?vue&type=script&lang=js"
export * from "./AsDetailComp.vue?vue&type=script&lang=js"
import style0 from "./AsDetailComp.vue?vue&type=style&index=0&id=4afde91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afde91a",
  null
  
)

export default component.exports